import React from 'react'
import { UserGroup } from '@Entities/user/user'
import TagComponent from '@Components/Tag'

interface TagsBlockProps {
    groups?: UserGroup[]
}

const TagsBlock = (props: TagsBlockProps) => (
    <div className="tags-block">
        {props.groups?.map((item: UserGroup) => (
            <TagComponent key={item.name} type="primary" name={item.name} />
        ))}
    </div>
)

export default TagsBlock
